import React, { Suspense } from "react";
import { useLandingTheme } from "../LandingThemeContext";
import { MossHero } from "./hero/MossHero";
import { LightJungleHero } from "./hero/LightJungleHero";

// Moss and Clearing are the designs visitors see; they load with the page. The other designs exist for
// the /testing preview and are fetched only when one is picked, keeping the home page's JavaScript small.
const FramerHero = React.lazy(() => import("./hero/FramerHero").then((module) => ({ default: module.FramerHero })));
const FieldGuideHero = React.lazy(() =>
  import("./hero/FieldGuideHero").then((module) => ({ default: module.FieldGuideHero }))
);
const NightLibraryHero = React.lazy(() =>
  import("./hero/NightLibraryHero").then((module) => ({ default: module.NightLibraryHero }))
);
const StickerHero = React.lazy(() => import("./hero/StickerHero").then((module) => ({ default: module.StickerHero })));
const GalleryHero = React.lazy(() => import("./hero/GalleryHero").then((module) => ({ default: module.GalleryHero })));
const BlueprintHero = React.lazy(() =>
  import("./hero/BlueprintHero").then((module) => ({ default: module.BlueprintHero }))
);

// The hero is where each version makes its thesis, so every theme has its own layout.
export default function HeroSection() {
  const theme = useLandingTheme();
  switch (theme.heroLayout) {
    case "moss":
      return <MossHero />;
    case "clearing":
    case "canopy":
    case "riverbank":
    case "diorama":
      return <LightJungleHero variant={theme.heroLayout} />;
    default:
      return (
        <Suspense fallback={null}>
          <PreviewHero heroLayout={theme.heroLayout} />
        </Suspense>
      );
  }
}

function PreviewHero({ heroLayout }: { heroLayout: string }) {
  switch (heroLayout) {
    case "fieldGuide":
      return <FieldGuideHero />;
    case "nightLibrary":
      return <NightLibraryHero />;
    case "sticker":
      return <StickerHero />;
    case "gallery":
      return <GalleryHero />;
    case "blueprint":
      return <BlueprintHero />;
    case "framer":
    default:
      return <FramerHero />;
  }
}
